// ENG-032 platform primitive: a surface with an optional title row.
import React from "react";
import styles from "./primitives.module.css";

export const Card: React.FC<{ title?: string; aside?: React.ReactNode; children: React.ReactNode }> = ({ title, aside, children }) => (
    <section className={styles.card}>
        {(title || aside) && (
            <div className={styles.cardHeader}>
                {title && <h2 className={styles.cardTitle}>{title}</h2>}
                {aside}
            </div>
        )}
        <div className={styles.cardBody}>{children}</div>
    </section>
);

export const CardGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className={styles.grid}>{children}</div>;

export const EmptyState: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className={styles.emptyState}>{children}</div>;
